import { Box, styled } from '@mui/material'
import { GridContainer } from '../Grid/GridContainer'
import { FOOTER_HEIGHT, PAGE_MAX_WIDTH, PAGE_WIDTH } from '../../theme'
import { Separator } from '../styles/Typography.styled'
import { mobile } from '../../utils/breakpoints'

export const FooterWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.palette.secondary.main};
  height: ${FOOTER_HEIGHT.desktop};
  align-content: center;

  ${({ theme }) =>
    mobile(theme, {
      height: FOOTER_HEIGHT.mobile,
    })}
`
export const FooterContent = styled(GridContainer)`
  width: ${PAGE_WIDTH.desktop};
  max-width: ${PAGE_MAX_WIDTH.desktop};
  margin: 0 auto;
  ${({ theme }) =>
    mobile(theme, {
      display: 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
      'justify-content': 'space-evenly',
      gap: 0,
      height: '100%',
    })}
`
export const FooterSeparator = styled(Separator)`
  background-color: ${({ theme }) => theme.palette.primary.contrastText};
`
